import cn from 'classnames'
import { FC } from 'react'

import styles from '../Dialog.module.scss'

type Props = {
  image: string
}

export const DialogImage: FC<Props> = ({ image }) => {
  return (
    <section className={cn(styles.dialogItem, styles.dialogItemImage)}>
      <img src={image} />
    </section>
  )
}
